module.exports = __webpack_public_path__ + "img/trainingPlan.3e394a1d.svg";